import { createBaseApi } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/base.api';

import { buildBaseQuery } from '@service/base-query.builder';

export const baseApi = createBaseApi(buildBaseQuery());
